export default function ViewLots({ data }) {
  return (
    <div>
      <h2 className="text-yellow-200 mb-2 text-lg lg:text-xl">Lots</h2>

      {data?.lots?.map((lot) => (
        <div key={lot.id} className="bg-gray-800 p-3 mb-2 rounded">
          <p className="text-xs lg:text-sm">{lot.farmer} - {lot.crop}</p>
          <p className="text-xs lg:text-sm">Qty: {lot.quantity} | Grade: {lot.grade}</p>
        </div>
      ))}
    </div>
  );
}